import Vue from 'vue'
import Vuex from 'vuex'
import {
    getBuildingsApi,
    getSiteMeterReadsApi,
    saveSiteMeterReadApi,
    getSiteMeterReadsByBuildingApi,
    submitBuildingReadsApi
} from "@/providers/backendApiService";
import {deleteItemDB, getAllItemsDB, getItemDB, saveItemDB} from "@/providers/indexedDbService";
import Auth from "@/store/modules/auth";
import dayJS from "dayjs"
//import {stubBuildings, stubReads} from "@/stub-data";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Auth
    },
    state: {
        user: {name: 'John Smith', email: 'fake@email.com', username: 'johnsmith'},
        activeBuildingId: null,
        buildings: [],
        buildingOrder: [],
        reads: [],
        dataFields: ['buildings', 'reads'],
        buildingsSearchInput: '',
        showAllBuildings: true        
    },
    getters: {
        activeBuilding(state) {
            if (state.activeBuildingId > 0)
                return state.buildings.find(building => building.buildingId === state.activeBuildingId);
        },
        
    },
    mutations: {
        async updateReadAtIndex(state, {read, index}) {   
            let reads = state.reads;
            reads[index] = read;
            // Use Vue.set to ensure reactivity when updating an array element
            Vue.set(state.reads, index, read);   
        },
        async setActiveBuilding(state, buildingId) {
            this.state.activeBuildingId = buildingId;
            await setMostRecent(buildingId);
            this.state.buildingOrder = JSON.parse(await getItemDB('user-settings', 'building-order'));
        }, 
        async updateBuildingsSearchInput(state, searchInput) {
            state.buildingsSearchInput = searchInput;
        },
        async updateShowAllBuildings(state, showAllBuildings) {
            state.showAllBuildings = showAllBuildings;
        }
    },
    actions: {
        async saveRead({state, commit}, read) {
            const index = state.reads?.findIndex(x =>  x.meterId === read.meterId);
            if (index !== undefined && index !== -1 
                    && (state.reads[index].meterRead !== read.meterRead 
                    || state.reads[index].meterNotes !== read.meterNotes
                    || read.imageOrUrl
                    || (state.reads[index].imageOrUrl && !read.imageOrUrl)
                    || state.reads[index].imagePath !== read.imagePath 
                    )) {
                
                // user has removed read, set to -1 so meter cleared on server
                if (!read.meterRead || read.meterRead.length === 0)
                    read.meterRead = -1;
                
                read.status = 'PENDING'
                // following log is required for debugging dev, demo, prod installs
                console.log(dayJS().format());
                read.meterReadDate = dayJS().format();
                if (navigator.onLine) {
                    try {
                        await saveSiteMeterReadApi(read);
                        if(read.imageOrUrl){
                            state.reads[index].imagePath = null;
                        }
                        read.status = 'SYNCED'
                    }
                    catch (err) {
                        console.error('saveRead',err)
                    }
                }
                // cleared read
                if (read.meterRead === -1) {
                    read.meterRead = null;
                    read.meterReadDate = null;
                    read.status = null
                }

                await saveItemDB('reads', read);
                commit('updateReadAtIndex', {read, index});
            }
        },
        async populateBuildingsFromCache({ state }) {
            if (navigator.onLine) {
                await loadBuildingsFromApi();
            }
            // state.buildings = await allValues('buildings');
            // if (state.buildings.length === 0) {
            //     stubBuildings.forEach(building => saveRecord('buildings', building));
            // }
            state.buildings = await getAllItemsDB('buildings');
            this.state.buildingOrder = JSON.parse(await getItemDB('user-settings', 'building-order'));
        },
        async populateReadsFromCache({state}, buildingId) {
            try {
                const success = await pushPendingMeterReadData();
                if (success) {
                    // pull all reads from server
                    await loadSiteMeterReadsFromApi(buildingId);
                }
                state.reads = await getAllItemsDB('reads');
            } catch (e) {
                console.error("[populateReadsFromCache] Error")
            }
        },
        async submitBuildingReads({state}, buildingId) {
            const index = this.state.buildings?.findIndex(
                building => building.buildingId === buildingId
            );
            if (index !== undefined && index !== -1) {
                const success = await pushPendingMeterReadData();
                if (success) {
                    try {
                        await submitBuildingReadsApi(buildingId);
                        state.buildings[index].status = 'SUBMITTED';
                        await buildingFullRefresh(buildingId);
                        state.buildings = await getAllItemsDB('buildings');
                    }
                    catch (err) {
                        console.error('[submitBuildingReads] error:',err)
                    }
                }

            }
        },
        async setBuildingsSearchInput({commit}, searchInput) {
            commit('updateBuildingsSearchInput', searchInput);
        },
        async setShowAllBuildings({commit}, showAllBuildings) {
            commit('updateShowAllBuildings', showAllBuildings);
        }
    }
})

async function setMostRecent(buildingId, type = 'unshift') {
    let buildingOrder = await getItemDB('user-settings', 'building-order') || '[]';
    buildingOrder = JSON.parse(buildingOrder);
    buildingOrder[type](buildingId);
    buildingOrder = Array.from(new Set(buildingOrder));
    await saveItemDB('user-settings', JSON.stringify(buildingOrder), 'building-order');
}

async function loadBuildingsFromApi() {
    const apiBuildings = await getBuildingsApi();
    if (apiBuildings === null) return;

    for (const building of apiBuildings) {
        await saveItemDB('buildings', building);
        await setMostRecent(building.buildingId, 'push');
    }
}

async function buildingFullRefresh(buildingId) {
    if (!navigator.onLine) {
        return;
    }
    const apiBuildings = await getBuildingsApi();
    let building = apiBuildings.find(b => b.buildingId === buildingId)
    if (building === undefined)
    {
        await deleteItemDB('buildings', buildingId);
    }
    await deleteReadsByBuilding(buildingId);
}

async function deleteReadsByBuilding(buildingId) {
    const dbReads = await getAllItemsDB('reads');
    const buildingReads = dbReads.filter(r => r.buildingId === buildingId);

    for (const read of buildingReads) {
        await deleteItemDB('reads', read.meterId);
    }
}

async function pushPendingMeterReadData() {
    if (!navigator.onLine) {
        return false;
    }

    // push pending reads
    const dbAllReads = await getAllItemsDB('reads');
    const pendingReads = dbAllReads.filter(function (r) {
        return r.status === 'PENDING'
    });

    try {
        for (const newRead of pendingReads) {
            if (!newRead.meterRead || newRead.meterRead.length === 0)
                newRead.meterRead = -1;
            await saveSiteMeterReadApi(newRead);
        }
    } catch (err) {
        console.error("[synchMeterReadData] push reads failed", err);
        return false;
    }

    return true;
}

async function loadSiteMeterReadsFromApi(buildingId) {
    let apiReads = undefined
    if (buildingId === -1) {
        apiReads = await getSiteMeterReadsApi();
    }
    else {
        apiReads = await getSiteMeterReadsByBuildingApi(buildingId);
    }
    for (const read of apiReads) {
        await saveItemDB('reads', read);
    }
}
